/* 太史慈傳共用的小工具：這條列傳才有的人物、兵種，以及讓村民（folk）沿路走的函式 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';
import { troop } from '../kit.ts';

const NEUTRAL_C = { armor: '#5a4a3a', sleeve: '#3a3028', cloth: '#3a3028', trim: '#b8a060', pants: '#2a2420', boot: '#2a2018', cape: null, belt: '#5a3a22', metal: '#8e979f', hood: '#3a3028', pole: '#5a3a22', plume: '#b8a060', band: '#b8a060' };
const P = (id, name, sub, role, weapon, look, skills) => H(id, name, sub, 'neutral', role, weapon, Object.assign({ fx: '#ffd8a0' }, look, { c: Object.assign({}, NEUTRAL_C, look.c) }), skills);

export const TSC_PEOPLE = {
  liupan: P('tsc_liupan', '劉磐', '劉表從子', '戰士', 'halberd', { eye: 'fierce', beard: 'mustache', bulk: 1.15, size: 1.12, c: { armor: '#4a5a7a', cloth: '#2e3a52', cape: '#5a6a8a', plume: '#8aa0c8' } }, [
    ['驍勇', 'crescent', '揮出戟氣，造成 {130/130/130/130} 傷害。'], ['寇掠', 'charge', '衝撞造成 {110/110/110/110} 傷害。'], ['橫戟', 'spin', '每圈 {55/55/55/55} 傷害。'], ['破縣', 'slam', '{170/170/170} 傷害。']]),
  mabao: P('tsc_mabao', '麻保賊帥', '賊帥', '戰士', 'axe', { head: 'headband', eye: 'fierce', beard: 'bushy', bulk: 1.2, size: 1.12, c: { armor: '#5a5040', cloth: '#4a4034', cape: '#6a5a40', band: '#8a6a40', plume: '#8a6a40' } }, [
    ['開山斧', 'crescent', '造成 {110/110/110/110} 傷害。'], ['蠻衝', 'charge', '衝撞造成 {90/90/90/90} 傷害。'], ['旋斧', 'spin', '每圈 {50/50/50/50} 傷害。'], ['困獸', 'slam', '{150/150/150} 傷害。']]),
};

export const TSC_TROOPS = {
  guard: troop('tsc-guard', '公車衛士', { armor: '#7a2a22', sleeve: '#5a1e18', cloth: '#5a1e18', plume: '#c0503a' }),
  shanyue: troop('tsc-shanyue', '山越', { armor: '#4a5a3a', sleeve: '#3a4a2e', cloth: '#3a4a2e', plume: '#7a9a50', metal: '#6a6a60' }),
  mabao: troop('tsc-mabao', '麻保賊', { armor: '#5a5040', sleeve: '#4a4034', cloth: '#4a4034', plume: '#8a6a40', metal: '#6a6a60' }),
  liupan: troop('tsc-liupan', '劉磐兵', { armor: '#4a5a7a', sleeve: '#2e3a52', cloth: '#2e3a52', plume: '#8aa0c8' }),
};

// 村民沿著 pts 走（速度 sp）；走到底回傳 true。f.pi 記走到第幾點
export function walk(f, pts, sp, dt) {
  if (f.pi == null) f.pi = 0;
  while (f.pi < pts.length) {
    const p = pts[f.pi], dx = p[0] - f.x, dy = p[1] - f.y, L = Math.hypot(dx, dy), s = sp * dt;
    if (L > s) { f.x += (dx / L) * s; f.y += (dy / L) * s; f.f = dx < 0 ? -1 : 1; f.walk = true; f.home = [f.x, f.y]; return false; }
    f.x = p[0]; f.y = p[1]; f.pi++;
  }
  f.walk = false;
  return true;
}
// 村民走向 (x, y)，停在 stop 以外
export function toward(f, x, y, sp, dt, stop = 0) {
  const dx = x - f.x, dy = y - f.y, L = Math.hypot(dx, dy);
  if (L <= stop + 1) { f.walk = false; return true; }
  const s = Math.min(L - stop, sp * dt);
  f.x += (dx / L) * s; f.y += (dy / L) * s; f.f = dx < 0 ? -1 : 1; f.walk = true; f.home = [f.x, f.y];
  return false;
}

// 箭靶「的」
export function target(ctx, f) {
  ctx.save(); ctx.translate(f.x, f.y);
  ctx.strokeStyle = '#5a3a22'; ctx.lineWidth = 4; ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(0, -60); ctx.stroke();
  for (const [r, c] of [[22, '#e9dcb8'], [15, '#b0443a'], [8, '#e9dcb8'], [3, '#b0443a']]) { ctx.fillStyle = c; ctx.beginPath(); ctx.arc(0, -70, r, 0, Math.PI * 2); ctx.fill(); }
  ctx.restore();
}
// 車（州吏的章就放在車上）
export function cart(ctx, f) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 4, 50, 12, 80, 0.3);
  poly(ctx, [[-44, -12], [44, -12], [44, -28], [-44, -28]], '#7a5634', 2);
  for (const x of [-26, 26]) { ctx.beginPath(); ctx.arc(x, -6, 12, 0, Math.PI * 2); SG.draw.ink(ctx, '#4a3424', 2); }
  poly(ctx, [[-38, -28], [38, -28], [34, -54], [-34, -54]], '#8a3a2a', 1.6);
  ctx.restore();
}
// 篋（曹操送來的，裡面只有當歸）
export function box(ctx, f) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 2, 26, 8, 40, 0.3);
  poly(ctx, [[-24, 0], [24, 0], [24, -26], [-24, -26]], '#6a3a22', 2);
  poly(ctx, [[-26, -26], [26, -26], [22, -34], [-22, -34]], '#8a4a2a', 2);
  ctx.fillStyle = '#c9a24e'; ctx.fillRect(-4, -22, 8, 10);
  ctx.restore();
}
// 樓：屯門上的木樓（樓棼是樓頂的橫梁）
export function tower(ctx, f) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  poly(ctx, [[-170, 0], [170, 0], [170, -150], [-170, -150]], '#5a3a22', 2.4);
  for (const x of [-150, -50, 50, 150]) { ctx.strokeStyle = '#3a2416'; ctx.lineWidth = 6; ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, -230); ctx.stroke(); }
  poly(ctx, [[-200, -230], [200, -230], [170, -270], [-170, -270]], '#4a3020', 2.4); // 樓棼
  ctx.restore();
}
